'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

function AltExtensions(A) {
  var orElse = function (fallback, init) {
    return Curry._2(A.alt, init, fallback);
  };
  return {
          orElse: orElse
        };
}

function AltInfix(A) {
  return {
          $less$pipe$great: A.alt
        };
}

exports.AltExtensions = AltExtensions;
exports.AltInfix = AltInfix;
/* No side effect */
